import { usePersonalAgents } from '../hooks/usePersonalAgents';

export function Footer() {
    const year = new Date().getFullYear();
    const personalAgents = usePersonalAgents();
    return (
        <footer className="tkh-footer">
            <div className="tkh-wrap">
                <div className="grid">
                    <div>
                        <div className="brand">
                            <img src="/assets/logo.png" alt="Turkish Airlines" />
                            <span>MCP Server</span>
                        </div>
                        <p className="brand-blurb">A Model Context Protocol server built by Turkish Airlines Digital Lab so AI assistants can serve passengers with live airline data.</p>
                    </div>
                    <div>
                        <h4>Connect</h4>
                        <ul>
                            <li>
                                <a href="https://claude.com/connectors/turkish-airlines" target="_blank" rel="noopener noreferrer">
                                    Turkish Airlines on Claude
                                </a>
                            </li>
                            <li>
                                <a href="https://chatgpt.com/apps/turkish-airlines/asdk_app_69450d740e508191bdb697e0ac33717d" target="_blank" rel="noopener noreferrer">
                                    Turkish Airlines on ChatGPT
                                </a>
                            </li>
                            <li>
                                <a href="https://modelcontextprotocol.io" target="_blank" rel="noopener noreferrer">
                                    About MCP
                                </a>
                            </li>
                            {personalAgents && (
                                <li>
                                    <a href="/personal-agents">Personal agents</a>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div>
                        <h4>Turkish Airlines</h4>
                        <ul>
                            <li>
                                <a href="https://www.turkishairlines.com" target="_blank" rel="noopener noreferrer">
                                    turkishairlines.com
                                </a>
                            </li>
                            <li>
                                <a href="https://www.turkishairlines.com/en-tr/legal-notice/privacy-policy/" target="_blank" rel="noopener noreferrer">
                                    Privacy policy
                                </a>
                            </li>
                            <li>
                                <a href="mailto:digitallab@thy.com">digitallab@thy.com</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="legal">
                    <span>© {year} Turkish Airlines. All rights reserved.</span>
                    <span>Istanbul · Built on the Model Context Protocol</span>
                </div>
            </div>
        </footer>
    );
}
